import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react';

/**
 * Custom theme configuration for Palatium Fastigheter
 * Uses Inter font family for a modern, professional appearance
 */
const config = defineConfig({
  theme: {
    tokens: {
      fonts: {
        heading: {
          value:
            'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
        },
        body: {
          value:
            'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
        },
      },
    },
  },
});

/**
 * Export the custom system combining Chakra's defaults with our configuration
 */
export const system = createSystem(defaultConfig, config);
